import { render } from "./Mv.vue?vue&type=template&id=60a83b4c&scoped=true"
import script from "./Mv.vue?vue&type=script&lang=js"
export * from "./Mv.vue?vue&type=script&lang=js"

import "./Mv.vue?vue&type=style&index=0&id=60a83b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a83b4c"]])

export default __exports__